export const linkTokens = {
  link: {
    root: {
      color: '{primary.color}',
      hoverColor: '{primary.500}',
      focusBorderColor: '{primary.color}',
      visitedColor: '{surface.1000}',
      disabledColor: '{text.mutedColor}',
      borderRadius: '{borderRadius.sm}'
    }
  }
};

export type LinkTokens = typeof linkTokens;
